import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';

import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { FavoritesProvider } from './context/FavoritesContext';

import Header from './components/Header'; 
import Breadcrumbs from './components/Breadcrumbs';
import BottomNavBar from './components/BottomNavBar';
import Footer from './components/Footer'; 
import Modal from './components/Modal';
import WhatsAppWidget from './components/WhatsAppWidget';

// Sayfaları import ediyoruz
import HomePage from './pages/HomePage';
import AdminPanel from './pages/AdminPanel';
import AutoTrackingPanel from './components/AutoTrackingPanel';
import ProductDetail from './pages/ProductDetail';
import AuthPage from './pages/AuthPage'; 
import AboutPage from './pages/AboutPage';
import CartPage from './pages/CartPage';
import FavoritesPage from './pages/FavoritesPage';
import ProductsPage from './pages/ProductsPage';
import CheckoutPage from './pages/CheckoutPage';
import OrdersPage from './pages/OrdersPage';
import AccountPage from './pages/AccountPage';
import PrintableOrder from './pages/PrintableOrder';
import SSSPage from './pages/SSSPage'; 
import IadePage from './pages/IadePage';
import GizlilikPage from './pages/GizlilikPage';
import TeslimatPage from './pages/TeslimatPage';
// YENİ: Şifre güncelleme sayfasını import ediyoruz
import UpdatePasswordPage from './pages/UpdatePasswordPage';
import ShippingTestPage from './pages/ShippingTestPage';
import GuestOrderTrackingPage from './pages/GuestOrderTrackingPage';
import TrackingPage from './pages/TrackingPage';
import CategoriesPage from './pages/CategoriesPage';
import ContactPage from './pages/ContactPage';
import SizeGuidePage from './pages/SizeGuidePage';
import CollectionsPage from './pages/CollectionsPage';
import FlashSalePage from './pages/FlashSalePage';
import CategoryCampaignPage from './pages/CategoryCampaignPage';
import CareGuidePage from './pages/CareGuidePage';
// KAMPANYA TAKİP: CampaignTrackingPage import
import CampaignTrackingPage from './pages/CampaignTrackingPage';
// KAMPANYA ANALİZ: AdminCampaignAnalyticsPage import
import AdminCampaignAnalyticsPage from './pages/AdminCampaignAnalyticsPage';
import UserCampaignHistoryPage from './components/UserCampaignHistoryPage';
import UserCampaignHistoryPageSimple from './components/UserCampaignHistoryPageSimple';
// İADE YÖNETİMİ: OrdersPage.js içinde mevcut
// ÖDEME SONUÇ: Order success and failed pages
import OrderSuccessPage from './pages/OrderSuccessPage';
import OrderFailedPage from './pages/OrderFailedPage';
// ADMIN PAYMENT: Payment transactions dashboard
import AdminPaymentTransactions from './pages/AdminPaymentTransactions';
import AdminPaymentLogs from './pages/AdminPaymentLogs';
import AdminPaymentTestTools from './pages/AdminPaymentTestTools';

// NEW PAYMENT ADMIN PAGES - Lazy loaded for better performance
const AdminPaymentTestCards = React.lazy(() => import('./pages/AdminPaymentTestCards'));
const AdminPaymentSettings = React.lazy(() => import('./pages/AdminPaymentSettings'));

// Bu componentler sadece App.js içinde kullanıldığı için burada kalabilirler
function ProtectedRoute({ children }) {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="text-center py-20">Yükleniyor...</div>;
  }
  if (!session) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }
  return children;
}

function AdminRoute({ children }) {
    const { session, loading, isAdmin } = useAuth();
    const location = useLocation();

    if (loading) {
        return <div className="text-center py-20">Yükleniyor...</div>;
    }
    if (!session) {
        return <Navigate to="/auth" state={{ from: location }} replace />;
    }
    if (!isAdmin) {
        toast.error("Bu alana erişim yetkiniz yok.");
        return <Navigate to="/" replace />;
    }
    return children;
}

// Ana içerik ve Route yapısını yöneten component
function AppContent() {
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const openModal = (content) => {
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent(null);
    };

  return (
    <div className="flex flex-col min-h-screen bg-brand-bg font-sans">
      <ToastContainer position="bottom-right" autoClose={4000} hideProgressBar={false} />
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8">
        {!location.pathname.startsWith('/products/') && <Breadcrumbs />}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/sss" element={<SSSPage />} />
          <Route path="/iade-kosullari" element={<IadePage />} />
          <Route path="/gizlilik-politikasi" element={<GizlilikPage />} />
          <Route path="/teslimat-bilgileri" element={<TeslimatPage />} />
          <Route path="/iletisim" element={<ContactPage />} />
          <Route path="/beden-rehberi" element={<SizeGuidePage />} />
          <Route path="/bakim-rehberi" element={<CareGuidePage />} />
          <Route path="/collections/:collectionSlug" element={<CollectionsPage />} />
          <Route path="/flash-sale" element={<FlashSalePage />} />
          <Route path="/category-campaign" element={<CategoryCampaignPage />} />
          <Route path="/category-campaign/:campaignId" element={<CategoryCampaignPage />} />
          <Route path="/flash-sale/:campaignId" element={<FlashSalePage />} />

          {/* YENİ: Şifre güncelleme sayfası için route (adres) tanımı */}
          <Route path="/update-password" element={<UpdatePasswordPage />} />
          <Route path="/shipping-test" element={<AdminRoute><ShippingTestPage /></AdminRoute>} />

          <Route path="/cart" element={<CartPage />} />
          <Route path="/favorites" element={<FavoritesPage />} />
          
          <Route path="/my-account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
          <Route path="/my-orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
          {/* KAMPANYA TAKİP: Kampanya takip sayfası rotası */}
          <Route path="/campaign-tracking" element={<ProtectedRoute><CampaignTrackingPage /></ProtectedRoute>} />
          {/* YENİ: Kampanya geçmişi sayfası */}
          <Route path="/campaign-history" element={<ProtectedRoute><UserCampaignHistoryPageSimple /></ProtectedRoute>} />
          <Route path="/campaign-history-full" element={<ProtectedRoute><UserCampaignHistoryPage /></ProtectedRoute>} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/order-success" element={<OrderSuccessPage />} />
          <Route path="/order-failed" element={<OrderFailedPage />} />
          <Route path="/guest-order-tracking" element={<GuestOrderTrackingPage />} />
          <Route path="/kargo-takip" element={<TrackingPage />} />
          <Route path="/kargo-takip/:trackingCode" element={<TrackingPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/categories/:categorySlug" element={<CategoriesPage />} />

          <Route path="/admin" element={<AdminRoute><AdminPanel openModal={openModal} closeModal={closeModal} /></AdminRoute>} />
          {/* KAMPANYA ANALİZ: Admin campaign analytics route */}
          <Route path="/admin/campaign-analytics" element={<AdminRoute><AdminCampaignAnalyticsPage /></AdminRoute>} />
          {/* PAYMENT TRANSACTIONS: Admin payment transactions dashboard */}
          <Route path="/admin/payment-transactions" element={<AdminRoute><AdminPaymentTransactions /></AdminRoute>} />
          {/* PAYMENT LOGS: Admin payment logs viewer */}
          <Route path="/admin/payment-logs" element={<AdminRoute><AdminPaymentLogs /></AdminRoute>} />
          {/* PAYMENT TEST TOOLS: Test cards and scenarios */}
          <Route path="/admin/payment-test-tools" element={<AdminRoute><AdminPaymentTestTools /></AdminRoute>} />
          {/* PAYMENT TEST CARDS: İyzico test cards (lazy loaded) */}
          <Route path="/admin/payment-test-cards" element={<AdminRoute><React.Suspense fallback={<div className="text-center py-20">Yükleniyor...</div>}><AdminPaymentTestCards /></React.Suspense></AdminRoute>} />
          {/* PAYMENT SETTINGS: Verbose logging toggle (lazy loaded) */}
          <Route path="/admin/payment-settings" element={<AdminRoute><React.Suspense fallback={<div className="text-center py-20">Yükleniyor...</div>}><AdminPaymentSettings /></React.Suspense></AdminRoute>} />
          <Route path="/admin/auto-tracking" element={<AdminRoute><AutoTrackingPanel /></AdminRoute>} />
          <Route path="/print-order/:id" element={<AdminRoute><PrintableOrder /></AdminRoute>} />
          {/* İADE YÖNETİMİ: OrdersPage.js'de /my-orders rotası altında mevcut */}
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <BottomNavBar />
      <WhatsAppWidget />
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        {modalContent}
      </Modal>
    </div>
  );
}

// Ana App component'i, tüm provider'ları sarar
function App() {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <FavoritesProvider>
            <CartProvider>
              <AppContent />
            </CartProvider>
          </FavoritesProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
